import moment from "moment-timezone";

const scorecardPrefixKey = "scorecard";
export let _retrieveStorageKey = (user) => {

	let usernameKey = user ? user.userName : "";
    let scorecardSelectionKey = (scorecardPrefixKey + ":" + usernameKey).toUpperCase();
    
    return scorecardSelectionKey;
}

export let _checkLocalStorageExpiration = (expirationDate) => {

    let isValid;
    if(expirationDate) {
        let _eDate = moment(expirationDate);
        if(_eDate) {
            let dateTimeNow = moment();
            isValid = dateTimeNow.isBefore(_eDate);
        }
    }
    return isValid
}


// WEBPACK FOOTER //
// ./src/features/scorecard/shared/UtilityHelper.js